import React from "react";

const RouteLoader = () => (
  <div className="route-loader" role="status" aria-live="polite">
    <span className="route-loader__jar" aria-hidden="true" />
    <p>Opening the pantry…</p>
  </div>
);

export default RouteLoader;
